import { render } from "./AssignmentList.vue?vue&type=template&id=8d116a8e&scoped=true"
import script from "./AssignmentList.vue?vue&type=script&lang=js"
export * from "./AssignmentList.vue?vue&type=script&lang=js"

import "./AssignmentList.vue?vue&type=style&index=0&id=8d116a8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d116a8e"]])

export default __exports__